module.exports = __webpack_public_path__ + "img/oracle.557e5de8.svg";